import React from 'react';
import { useParams } from 'react-router-dom';
import i18n from 'i18next';
import PropTypes from 'prop-types';

import { NoAccess } from '@/exceed';

const VideosUnauthorizedContainer =  ({ hasBreadcrumbs = true, isLearner = false }) => {
  const { orgId, type } = useParams();
  const getBreadcrumbs = () => [{
    text: i18n.t('videos'),
    path: isLearner ? '/student/videos/home' : `/videos/organizations/${orgId}/${type}`,
    key: 'videosHomePage',
  },
  {
    text: i18n.t('no-access'),
    path: '',
    key: '',
  }];

  return (
    <NoAccess
      hasBreadcrumbs={hasBreadcrumbs}
      breadcrumbs={hasBreadcrumbs && getBreadcrumbs()}
      title={isLearner ? i18n.t('learner-no-access-title') : i18n.t('no-access-title')}
      body={isLearner ? i18n.t('learner-no-access-body') : i18n.t('no-access-body')}
    />
  );
};

VideosUnauthorizedContainer.propTypes = {
  isLearner: PropTypes.bool,
  hasBreadcrumbs: PropTypes.bool
};

export default VideosUnauthorizedContainer;
